import { NonF2fMedicalCategory } from '@/types/bff/gql-schema';
import useMedicalCategoryDisplayViewModel from '../hooks/useMedicalCategoryDisplayViewModel';
import { MEDICAL_CATEGORY_CONFIG } from '../lib/constants';
import { CategoryData } from '../types/category';
import CategoryGrid from './CategoryGrid';
import CategoryItem from './CategoryItem';

const MedicalCategoryGrid = () => {
  const { medicalCategories, isLoading, onClickCategory, onClickMoreCategory } = useMedicalCategoryDisplayViewModel(
    MEDICAL_CATEGORY_CONFIG.DEFAULT_DISPLAY_SIZE
  );

  const handleCategoryClick = (category: CategoryData) => {
    if (category.id === 'more') {
      onClickMoreCategory();
    } else {
      onClickCategory(category as NonF2fMedicalCategory);
    }
  };

  return (
    <CategoryGrid isLoading={isLoading}>
      {medicalCategories.map((category) => (
        <CategoryItem key={category.id} category={category} onClick={handleCategoryClick} />
      ))}
    </CategoryGrid>
  );
};

export default MedicalCategoryGrid;
